import http from '@/utils/http'
import convert from '@/utils/model-convert'
import { SearchArgument, UserSearchArgument, FormArgument } from '@/models/client/resource'

const URL = '/rest/customer/feedback/resource'
const OPERATE_URL = '/rest/customer/feedback/resource/{id}'
const READ_URL = '/rest/customer/feedback/resource/{id}/read'
const UNREAD_URL = '/rest/customer/feedback/resource/{id}/unread'
const SUMMARY_URL = '/rest/customer/feedback/resource/summary'
const DELETE_URL = '/rest/customer/feedback/resource/{id}/delete'
const DELETE_LIST_URL = '/rest/customer/feedback/resource/deleteList'
const DELETE_LIST_URL1 = '/rest/customer/feedback/resource-distribution/ids/del-status'
const USER_LINKNESS_URL = '/rest/es/crmuser/like'
const USER_SPE_LINKNESS_URL = '/rest/es/crmchannelsource/like' // 模糊查询客户来源，仅限个别用户
const SPE_DISTRIBUTE_URL = '/rest/es/eccutomerdistribute/assignResourcesManuallyByChannelSource' // 手动分配资源-按客人来源，仅限个别用户
const DISTRIBUTE_URL = '/rest/es/eccutomerdistribute/assignResourcesManually'
const ALL_READ_URL = '/rest/customer/feedback/resource/ids/read/many' // 批量已读
const ALL_READ_URL1 = '/rest/customer/feedback/resource-distribution/ids/read' // 批量已读
const ALL_UNREAD_URL = '/rest/customer/feedback/resource/ids/unread/many' // 批量未读
const ALL_UNREAD_URL1 = '/rest/customer/feedback/resource-distribution/ids/unread' // 批量未读
const CRM_RESOURCE_TYPE_URL = '/rest/es/eccutomerdistribute/getCrmAssignResourceType' // 获取Crm资源分配的方式
const ASSIGN_RESOURCES_MANUALLY_BY_THRIDPUSH_URL = '/rest/es/eccutomerdistribute/AssignResourcesManuallyByThridPush' // 手动分配资源-直接推送

export default {
  deleteList ({ids}, cb) {
    http.put(DELETE_LIST_URL, ids, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  deleteList1 ({ids}, cb) {
    http.put(DELETE_LIST_URL1, ids, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  allReadList ({ids}, cb) {
    http.put(ALL_READ_URL, ids, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  allReadList1 ({ids}, cb) {
    http.put(ALL_READ_URL1, ids, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  allUnreadList ({ids}, cb) {
    http.put(ALL_UNREAD_URL, ids, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  allUnreadList1 ({ids}, cb) {
    http.put(ALL_UNREAD_URL1, ids, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  likeness ({search}, cb) {
    http.get(USER_LINKNESS_URL, {
      params: convert.toJson(search, UserSearchArgument)
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  speLikeness ({search}, cb) {
    http.get(USER_SPE_LINKNESS_URL, {
      params: convert.toJson(search, UserSearchArgument)
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  distribute ({form}, cb) {
    const data = convert.toJson(form, FormArgument)
    http.put(DISTRIBUTE_URL, data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  speDistribute ({form}, cb) {
    const data = convert.toJson(form, FormArgument)
    http.put(SPE_DISTRIBUTE_URL, data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  delete ({id}, cb) {
    http.put(DELETE_URL.replace('{id}', id))
      .then(response => cb(response)).catch(trace => cb(trace.response))
  },
  list ({search}, cb) {
    http.get(URL, {
      params: convert.toJson(search, SearchArgument)
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  getSummary ({search}, cb) {
    http.get(SUMMARY_URL, {
      params: convert.toJson(search, SearchArgument)
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  modify ({id, remark}, cb) {
    http.put(OPERATE_URL.replace('{id}', id), {remark: remark}, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  read ({id}, cb) {
    http.put(READ_URL.replace('{id}', id))
      .then(response => cb(response)).catch(trace => cb(trace.response))
  },
  unread ({id}, cb) {
    http.put(UNREAD_URL.replace('{id}', id))
      .then(response => cb(response)).catch(trace => cb(trace.response))
  },
  getCrmAssignResourceType () {
    return http.get(CRM_RESOURCE_TYPE_URL)
  },
  assignResourcesManuallyByThridPush ({form}, cb) {
    const data = convert.toJson(form, FormArgument)
    http.put(ASSIGN_RESOURCES_MANUALLY_BY_THRIDPUSH_URL, data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  }
}



// WEBPACK FOOTER //
// ./src/api/client/resource.js